var _path, _path2, _path3, _path4, _path5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacility(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 344 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M308.224 300.931H35.776C31.9232 300.931 28.7584 297.766 28.7584 293.914V20.7776C28.7584 17.3376 31.5792 14.5168 35.0192 14.5168H307.467C311.733 14.5168 315.173 17.9568 315.173 22.2224V293.914C315.242 297.835 312.077 300.931 308.224 300.931Z",
    className: "illustration_primary-lightest"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.491 32.1296H46.4399V278.365H297.491V32.1296Z",
    className: "illustration_primary_default"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M340.766 329.483H3.44C1.5824 329.483 0 327.97 0 326.043V318.131H344V326.25C344 328.038 342.555 329.483 340.766 329.483Z",
    fill: "#FFE600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M344 318.131L297.56 281.736V203.373H46.44V281.736L0 318.131H344Z",
    className: "illustration_primary-light"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21380_15548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 32,
    width: 252,
    height: 247
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M297.491 32.1296H46.4399V278.365H297.491V32.1296Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21380_15548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.178 228.21H116.822C116.409 228.21 115.997 228.347 115.721 228.622L62.1951 271.76C60.8879 272.792 61.6447 274.925 63.2959 274.925H280.704C282.355 274.925 283.112 272.792 281.805 271.76L228.278 228.622C227.934 228.347 227.521 228.21 227.178 228.21Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.819 225.526H80.4271C79.2575 225.526 78.2255 224.563 78.2255 223.325V169.454C78.2255 168.285 79.1887 167.253 80.4271 167.253H103.819C104.989 167.253 106.021 168.216 106.021 169.454V223.325C106.021 224.563 104.989 225.526 103.819 225.526Z",
    className: "illustration_secondary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.402 171.45H78.8447C78.5007 171.45 78.2943 171.174 78.2943 170.899V167.872C78.2943 167.528 78.5695 167.322 78.8447 167.322H105.402C105.746 167.322 105.952 167.597 105.952 167.872V170.899C106.021 171.174 105.746 171.45 105.402 171.45Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.649 195.186C102.649 194.91 102.374 169.592 101.617 165.946C101.48 165.189 101.067 164.57 100.448 164.294C98.7278 163.4 95.9758 164.501 95.907 164.501L95.7694 164.088C95.907 164.019 98.7966 162.918 100.654 163.882C101.411 164.294 101.893 164.914 102.099 165.877C102.925 169.523 103.131 194.154 103.131 195.254L102.649 195.186Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.136 162.162C101.136 167.184 97.0766 167.115 92.123 167.115C87.1694 167.115 83.1102 167.184 83.1102 162.162C83.1102 157.139 87.1694 149.021 92.123 149.021C97.0766 149.021 101.136 157.139 101.136 162.162Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.507 155.282H79.739L87.0318 135.674H97.1454L104.507 155.282Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.374 180.05C101.824 180.05 101.411 179.637 101.411 179.086V176.472C101.411 175.922 101.824 175.509 102.374 175.509C102.925 175.509 103.337 175.922 103.337 176.472V179.086C103.337 179.637 102.925 180.05 102.374 180.05Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.374 178.742C102.099 178.742 101.893 178.536 101.893 178.33V177.298C101.893 177.091 102.099 176.885 102.305 176.885H102.374C102.581 176.885 102.787 177.091 102.787 177.298V178.33C102.787 178.536 102.65 178.742 102.374 178.742Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.181 225.526H263.573C264.742 225.526 265.774 224.563 265.774 223.325V169.454C265.774 168.285 264.811 167.253 263.573 167.253H240.181C239.011 167.253 237.979 168.216 237.979 169.454V223.325C237.979 224.563 239.011 225.526 240.181 225.526Z",
    className: "illustration_secondary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.598 171.45H265.155C265.499 171.45 265.706 171.174 265.706 170.899V167.872C265.706 167.528 265.43 167.322 265.155 167.322H238.598C238.254 167.322 238.048 167.597 238.048 167.872V170.899C237.979 171.174 238.254 171.45 238.598 171.45Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.208 195.598H242.795C242.795 194.566 243.07 169.936 243.827 166.221C244.034 165.326 244.515 164.638 245.272 164.226C247.13 163.262 250.019 164.363 250.157 164.432L250.019 164.845C250.019 164.845 247.198 163.744 245.478 164.638C244.859 164.982 244.446 165.533 244.309 166.29C243.483 169.936 243.208 195.323 243.208 195.598Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.864 162.162C242.864 167.184 246.923 167.115 251.877 167.115C256.83 167.115 260.889 167.184 260.889 162.162C260.889 157.139 256.83 149.021 251.877 149.021C246.923 149.021 242.864 157.139 242.864 162.162Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.493 155.282H264.261L256.968 135.674H246.854L239.493 155.282Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.414 179.843C243.965 179.843 244.378 179.43 244.446 178.88L244.515 176.266C244.515 175.715 244.102 175.302 243.552 175.234C243.002 175.234 242.589 175.646 242.52 176.197L242.451 178.811C242.52 179.362 242.933 179.774 243.414 179.843Z",
    fill: "#FF7945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.483 178.467C243.758 178.467 243.965 178.261 243.965 178.054L244.034 177.022C244.034 176.816 243.827 176.61 243.621 176.541H243.552C243.346 176.541 243.139 176.747 243.07 176.954L243.002 177.986C243.07 178.261 243.208 178.467 243.483 178.467Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.421 214.862H116.96C114.07 214.862 111.662 212.454 111.662 209.565V138.219C111.662 135.33 114.07 132.922 116.96 132.922H226.421C229.31 132.922 231.718 135.33 231.718 138.219V209.565C231.718 212.523 229.379 214.862 226.421 214.862Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.13 248.093H96.8703C93.3615 248.093 90.4719 245.272 90.4719 241.694V211.904H253.459V241.694C253.528 245.272 250.638 248.093 247.13 248.093Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.973 178.467H132.027L90.4719 211.973H253.528L211.973 178.467Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.077 181.219L221.398 177.504C219.816 176.266 217.89 175.578 215.963 175.578H128.106C126.11 175.578 124.184 176.266 122.67 177.504L117.442 181.77L226.077 181.219Z",
    className: "illustration_primary-lightest"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.373 181.701L95.4255 199.382C89.0271 204.542 92.6735 214.862 100.861 214.862H243.139C251.326 214.862 254.973 204.542 248.574 199.382L226.008 181.219L117.373 181.701Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.186 260.752H101.962C100.586 260.752 99.4847 259.651 99.4847 258.275V241.488C99.4847 240.112 100.586 239.011 101.962 239.011H109.186C110.562 239.011 111.662 240.112 111.662 241.488V258.275C111.662 259.651 110.562 260.752 109.186 260.752Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.901 260.752H234.677C233.301 260.752 232.2 259.651 232.2 258.275V241.488C232.2 240.112 233.301 239.011 234.677 239.011H241.901C243.277 239.011 244.378 240.112 244.378 241.488V258.275C244.378 259.651 243.277 260.752 241.901 260.752Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.544 184.109L227.728 180.669L115.653 181.15L112.144 183.971C111.181 184.728 111.731 186.31 112.969 186.31H231.718C232.888 186.379 233.438 184.866 232.544 184.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.336 177.573H139.87C136.293 177.573 133.334 174.614 133.334 171.037V162.506C133.334 158.928 136.293 155.97 139.87 155.97H161.336C164.914 155.97 167.872 158.928 167.872 162.506V171.037C167.872 174.614 164.914 177.573 161.336 177.573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.13 177.573H182.664C179.086 177.573 176.128 174.614 176.128 171.037V162.506C176.128 158.928 179.086 155.97 182.664 155.97H204.13C207.707 155.97 210.666 158.928 210.666 162.506V171.037C210.666 174.614 207.707 177.573 204.13 177.573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.291 203.854H105.608C105.333 203.854 105.195 203.648 105.195 203.442C105.195 203.235 105.401 203.029 105.608 203.029H237.291C237.566 203.029 237.704 203.235 237.704 203.442C237.704 203.648 237.566 203.854 237.291 203.854Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.856 102.374C186.654 102.925 184.315 103.2 181.976 103.2C166.496 103.2 153.906 90.6095 153.906 75.1295C153.906 59.6495 166.427 47.0591 181.976 47.0591C184.384 47.0591 186.654 47.3343 188.856 47.8847C179.018 52.9759 172.344 63.2271 172.344 75.0607C172.344 87.0319 179.018 97.2831 188.856 102.374Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.0319 135.674L34.3311 66.392L28.7583 14.5168L171.381 11.2144L97.1455 135.674H87.0319Z",
    fill: "#FFE600"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.83 135.674L309.6 66.392L315.104 14.5168L172.55 11.2144L246.785 135.674H256.83Z",
    fill: "#FFE600"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacility);
export default __webpack_public_path__ + "static/media/Facility.c1e33784.svg";
export { ForwardRef as ReactComponent };